export default "__VITE_ASSET__ZClv1xV1__"